import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Albumdiscographygrid from "./sections/Albumdiscographygrid";
import CinematicIdentity from "./sections/CinematicIdentity";
import TheShowreel from "./sections/TheShowreel";
import SonicSolutions from "./sections/SonicSolutions";
import StartAProject from "./sections/StartAProject";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Albumdiscographygrid />
      <CinematicIdentity />
      <TheShowreel />
      <SonicSolutions />
      <StartAProject />
      <Footer />
    </div>;
}